import {
  AlertCircle,
  Award,
  Badge,
  Bell,
  Bitcoin,
  Bolt,
  Book,
  Briefcase,
  Building,
  CalendarCheck,
  Captions,
  CheckCircle,
  Code,
  Codepen,
  Coffee,
  File as DocumentIcon,
  Euro,
  Eye,
  File,
  FileQuestion,
  FileText,
  Flag,
  Ghost,
  Gift,
  Grid,
  Heart,
  HelpCircle,
  Kanban,
  Key,
  Layout,
  LayoutGrid,
  LifeBuoy,
  MessageSquare,
  Monitor,
  Network,
  Users as PeopleIcon,
  Plug,
  ScrollText,
  Settings,
  Share2,
  Shield,
  ShieldUser,
  ShoppingCart,
  SquareMousePointer,
  Star,
  Theater,
  TrendingUp,
  UserCheck,
  UserCircle,
  Users,
  Briefcase as WorkIcon,
  Zap,
} from 'lucide-react';

export const MENU_SIDEBAR = [
  {
    title: 'Company',
    icon: Building,
    children: [
      { title: 'Übersicht', path: '/company/overview' },
      { title: 'Mitarbeiter', path: '/company/members' },
      { title: 'Adressenverwaltung', path: '/company/addresses' },
      { title: 'Social Media Integration', path: '/company/integrations' },
    ],
  },
  {
    title: 'Dashboards',
    icon: LayoutGrid,
    children: [
      { title: 'Light Sidebar', path: '/' },
    ],
  },
  { heading: 'User' },
  
  {
    title: 'Mein Konto',
    icon: Settings,
    children: [
      { title: 'Benutzerprofil', path: '/profile' },
      { title: 'Einstellungen', path: '/settings' },
      {
        title: 'Zahlungen & Provisionen',
        children: [
          { title: 'Tarife', path: '/admin/company?tab=billing&sub=plans' },
          { title: 'Guthaben', path: '/admin/company?tab=billing&sub=wallet' },
          { title: 'Zahlungsmethoden', path: '/admin/company?tab=billing&sub=payment-methods' },
          { title: 'Belege', path: '/admin/company?tab=billing&sub=invoices' },
        ],
      },
    ],
  },
  
  {
    title: 'Authentication',
    icon: Shield,
    children: [
      {
        title: 'Sign In',
        path: '/signin',
      },
      {
        title: 'Check Email',
        path: '/signup',
      },
      {
        title: 'Reset Password',
        path: '/reset-password',
      },
      {
        title: '2FA',
        path: '/2fa',
      },
      { title: 'Welcome Message', path: '/auth/welcome-message' },
      { title: 'Account Deactivated', path: '/auth/account-deactivated' },
      { title: 'Error 404', path: '/error/404' },
      { title: 'Error 500', path: '/error/500' },
    ],
  },
  { heading: 'Apps' },
  {
    title: 'User Management',
    icon: ShieldUser,
    children: [
      {
        title: 'Users',
        path: '/user-management/users',
      },
      {
        title: 'Roles',
        path: '/user-management/roles',
      },
      {
        title: 'Permissions',
        path: '/user-management/permissions',
      },
      {
        title: 'Account',
        path: '/user-management/account',
      },
      {
        title: 'Logs',
        path: '/user-management/logs',
      },
      {
        title: 'Settings',
        path: '/user-management/settings',
      },
    ],
  },
      ];

export const MENU_SIDEBAR_CUSTOM = [
];

export const MENU_SIDEBAR_COMPACT = [
  {
    title: 'Dashboards',
    icon: LayoutGrid,
    path: '/',
  },
  
  {
    title: 'Mein Konto',
    icon: Settings,
    children: [
      { title: 'Benutzerprofil', path: '/profile' },
      { title: 'Einstellungen', path: '/settings' },
      {
        title: 'Zahlungen & Provisionen',
        children: [
          { title: 'Tarife', path: '/admin/company?tab=billing&sub=plans' },
          { title: 'Guthaben', path: '/admin/company?tab=billing&sub=wallet' },
          { title: 'Zahlungsmethoden', path: '/admin/company?tab=billing&sub=payment-methods' },
          { title: 'Belege', path: '/admin/company?tab=billing&sub=invoices' },
        ],
      },
    ],
  },
  
  
  {
    title: 'User Management',
    icon: ShieldUser,
    children: [
      {
        title: 'Users',
        path: '/user-management/users',
      },
      {
        title: 'Roles',
        path: '/user-management/roles',
      },
      {
        title: 'Permissions',
        path: '/user-management/permissions',
      },
      {
        title: 'Account',
        path: '/user-management/account',
      },
      {
        title: 'Logs',
        path: '/user-management/logs',
      },
      {
        title: 'Settings',
        path: '/user-management/settings',
      },
    ],
  },
  {
    title: 'Authentication',
    icon: Shield,
    children: [
      {
        title: 'Sign In',
        path: '/signin',
      },
      {
        title: 'Check Email',
        path: '/signup',
      },
      {
        title: 'Reset Password',
        path: '/reset-password',
      },
      {
        title: '2FA',
        path: '/2fa',
      },
      { title: 'Welcome Message', path: '/auth/welcome-message' },
      { title: 'Account Deactivated', path: '/auth/account-deactivated' },
      { title: 'Error 404', path: '/error/404' },
      { title: 'Error 500', path: '/error/500' },
    ],
  },
];

export const MENU_MEGA = [
  { title: 'Home', path: '/' },
  
    {
    title: 'My Account',
    children: [
      {
        title: 'Mein Konto',
        children: [
          { title: 'Benutzerprofil', path: '/profile' },
          { title: 'Einstellungen', path: '/settings' },
        ],
      },
      {
        title: 'Zahlungen & Provisionen',
        children: [
          { title: 'Tarife', path: '/admin/company?tab=billing&sub=plans' },
          { title: 'Guthaben', path: '/admin/company?tab=billing&sub=wallet' },
          { title: 'Zahlungsmethoden', path: '/admin/company?tab=billing&sub=payment-methods' },
          { title: 'Belege', path: '/admin/company?tab=billing&sub=invoices' },
        ],
      },
    ],
  },
];

export const MENU_MEGA_MOBILE = [
  { title: 'Home', path: '/' },
  
    {
    title: 'My Account',
    children: [
      {
        title: 'Mein Konto',
        children: [
          { title: 'Benutzerprofil', path: '/profile' },
          { title: 'Einstellungen', path: '/settings' },
        ],
      },
      {
        title: 'Zahlungen & Provisionen',
        children: [
          { title: 'Tarife', path: '/admin/company?tab=billing&sub=plans' },
          { title: 'Guthaben', path: '/admin/company?tab=billing&sub=wallet' },
          { title: 'Zahlungsmethoden', path: '/admin/company?tab=billing&sub=payment-methods' },
          { title: 'Belege', path: '/admin/company?tab=billing&sub=invoices' },
        ],
      },
    ],
  },
  
  {
    title: 'User Management',
    icon: Users,
    children: [
      {
        title: 'Users',
        path: '/user-management/users',
      },
      {
        title: 'Roles',
        path: '/user-management/roles',
      },
      {
        title: 'Permissions',
        path: '/user-management/permissions',
      },
      {
        title: 'Account',
        path: '/user-management/account',
      },
      {
        title: 'Logs',
        path: '/user-management/logs',
      },
      {
        title: 'Settings',
        path: '/user-management/settings',
      },
    ],
  },
];

export const MENU_HELP = [
  {
    title: 'Getting Started',
    icon: Coffee,
    path: 'https://keenthemes.com/metronic/tailwind/docs/getting-started/installation',
  },
  {
    title: 'Support Forum',
    icon: AlertCircle,
    children: [
      {
        title: 'All Questions',
        icon: FileQuestion,
        path: 'https://devs.keenthemes.com',
      },
      {
        title: 'Popular Questions',
        icon: Star,
        path: 'https://devs.keenthemes.com/popular',
      },
      {
        title: 'Ask Question',
        icon: HelpCircle,
        path: 'https://devs.keenthemes.com/question/create',
      },
    ],
  },
  {
    title: 'Licenses & FAQ',
    icon: Captions,
    path: 'https://keenthemes.com/metronic/tailwind/docs/getting-started/license',
  },
  {
    title: 'Documentation',
    icon: FileQuestion,
    path: 'https://keenthemes.com/metronic/tailwind/docs',
  },
  { separator: true },
  { title: 'Contact Us', icon: Share2, path: 'https://keenthemes.com/contact' },
];

export const MENU_ROOT = [
  {
    title: 'Account',
    icon: Settings,
    rootPath: '/account/',
    path: '/',
    childrenIndex: 2,
  },
  
  {
    title: 'Authentication',
    icon: Shield,
    rootPath: '/authentication/',
    path: '/authentication/get-started',
    childrenIndex: 3,
  },
  
  {
    title: 'User Management',
    icon: ShieldUser,
    rootPath: '/user-management/',
    path: '/user-management/users',
    childrenIndex: 4,
  },
];
